import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';

export default function ReactionBar({ reactions, onToggleReaction }) {
    const { theme } = useTheme();
    const { currentUser } = useAuth();

    if (!reactions || reactions.length === 0) return null;

    return (
        <div className="flex flex-wrap gap-1 mt-1">
            {reactions.map((reaction) => {
                const userReacted = reaction.users?.some(u => u.id === currentUser?.id);
                return (
                    <button
                        key={reaction.emoji}
                        onClick={() => onToggleReaction(reaction.emoji)}
                        className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs border transition-colors ${
                            userReacted
                                ? theme === 'dark'
                                    ? 'bg-blue-900/40 border-blue-500/50 text-blue-300'
                                    : 'bg-blue-50 border-blue-300 text-blue-700'
                                : theme === 'dark'
                                    ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                                    : 'bg-gray-100 border-gray-200 text-gray-600 hover:bg-gray-200'
                        }`}
                        title={reaction.users?.map(u => u.username).join(', ')}
                    >
                        <span>{reaction.emoji}</span>
                        <span>{reaction.count}</span>
                    </button>
                );
            })}
        </div>
    );
}
